<template>
			<div class="guidance-wrapper">
				<div class="title">
					<div class="text"><h3>- 診断結果に関して -</h3>
						<h2>自分自身の内向性を<br>
							より良く活かした<br>
							人生のリスタートを</h2>
						<p class="en">Guidance your Introvert</p>
					</div>
					<img src="../assets/result-index-guidance.svg" alt="*">
				</div>
				<div class="sentence">
					<div v-if="levelResult.percentage >= 85" class="branch">
						<div class="type">
							<span>Your Intorvet</span>Extreme Type
						</div><!-- end .type -->
						<h2>セルフプロデュースの才を持つハイスコア内向型</h2>
						<p>本診断であなたの内向度は{{levelResult.percentage}}%となりました。あなたの内向度は非常に強く、まさにあなたは内向型の人間と言えるでしょう。{{levelResult.percentage}}%といった極端に高い内向性は、才能の原石です。なぜなら、内向度強ければ強いほど、他人よりも考え抜く力が増すからです。結果、あなたは他人よりずっと論理的、他人よりずっと創造的な潜在能力を持っていると言えます。</p>
						<p>起業家、専門家、アーティスト、アスリートなど、あらゆる分野でかなりの活躍が期待できます。あなたの輝きたい方向に輝く、その素質と資格があなたには備わっているのです。特に、個人プレーで深い専門や複雑な思考が求められる分野は、あなたにマッチしていると言えるでしょう。</p>
					</div><!-- end .branch -->
					<div v-if="levelResult.percentage < 85 && levelResult.percentage >= 65" class="branch">
						<div class="type">
							<span>Your Intorvet</span>Middle Type
						</div><!-- end .type -->
						<h2>マルチな分野で活躍が期待できるミドルスコア内向型</h2>
						<p>本診断であなたの内向度は{{levelResult.percentage}}%となりました。あなたの内向度は強く、内向型の人間と言えるでしょう。{{levelResult.percentage}}%といった数字は、これからまだまだ自分の内向性を高めることも意味します。内向性は、自己対話、自分会議によるアイデアやクリエイティブの厳選です。また、専門度が高い知識やスキルの習得も内向度が高いほうが非常に有利と言えます。</p>
						<p>つまり、あなたはこれからまだまだ内向度を高めることで、起業家、専門家、アーティスト、アスリートなど、あらゆる分野でかなりの活躍が期待できます。こうした分野で大きな活躍をする人は、自身の内向性の感覚を日々磨いているのです。あなたは個人プレーで深い専門や複雑な思考が求められる分野は、あなたにマッチしていますが、極端に内向的な人をサポートする右腕としても大いなる活躍が期待できます。</p>
						<p>極端に内向的なタイプよりも、ある程度の深堀りで留める傾向があるので、複数の専門性やスキルを身に着けて、自分の強みにするような動きはあなたに合っています。主体的に自分を築ける環境がやはりあなたにはフィットするでしょう。</p>
					</div><!-- end .branch -->
					<div v-if="levelResult.percentage < 65 && levelResult.percentage >= 50" class="branch">
						<div class="type">
							<span>Your Intorvet</span>Brance Type
						</div><!-- end .type -->
						<h2>内向度がやや高く外向性の特徴を併せ持つバランス型</h2>
						<p>本診断であなたの内向度は{{levelResult.percentage}}%となりました。あなたの内向度は強く、内向型の人間と言えるでしょう。{{levelResult.percentage}}%といった数字は、やや軽微な内向性と外向性を持っています。誰と絡んでも、どんな物事でもある程度のレベルであれば無難にこなすことができます。チームの中で、非常に求められることが多く、個人プレーよりもチームプレーの中でこそあなたの価値は認知されやすいと言えます。</p>
						<p>あなたのようなタイプは、内向度が強い人からすれば、外向的に見られるでしょうし、外向性が強い人からすれば、内向的に映ることもあるでしょう。内向性及び外向性とは、思考や行動の個性に大きく関わるので、あなたは総合的にバランスの取れた常識人のように、他人から認識される傾向が多くなります。</p>
						<p>ただし、逆を言えば、これといった大きな強みを作りすづらい状況にあります。内向性を高めるか、外向性を高めるか、はたまた両方のバランスの質をもっと高めるか、あなたが個性的な特長を作るにはここからもう一歩前進が必要だとも言えます。チームの中でより自分を生かそうとするのであれば、内向度を高めるにしても、外向度を高めるにしても、コミュニケーションに関するスキルをセットすることがおすすめです。</p>
					</div><!-- end .branch -->

					
					<img src="../assets/result-index-img01.svg" alt="*" />
					<div class="caption">
						自身の内向性に沿ったマインドやスキルを積み上げることで、物事は自分らしさを出しながらうまくいくようになる
					</div><!-- end .caption -->
					<p>ただし、これは、あくまでも潜在能力に過ぎません。潜在能力を開花させ、実質的に世の中で活躍するためには、あらゆる場面で外向的スキルが求められます。そのため、あなたが自分自身の内向的特性にフィットしたマインドやスキルを積み上げていなければ、人生の多くのシーンでかなりの息苦しさを感じることになります。</p>
					<p>自分の適性とは、何も積み上げなければ、ただの潜在能力で終わります。潜在能力を引き出し、実力として世界に轟かせるには、その適性を生かすマインドやスキルを後天的に身に付けていく必要があるのです。</p>
					<p>既に満足いく結果を出し続けているのであれば、あなたは内向的人生のセルフプロデュースの術を知っているはずです。あなたは物事の本質を掴む思考力があります。正しい情報を手に入れ、確実に経験を増やせば、恋愛でも仕事でも「狙って結果を出す」ことができます。</p>
					<h3>自分の内向度を「大きな武器」にするために必要な3つの要素</h3>
					<p>内向度{{ levelResult.percentage }}%のあなたが、その才能を大いに発揮し、あらゆるシチュエーションで「狙って結果を出す」ためには、(1)マインドセット、(2)コミュニケーションスキル、(3)アウトプットスキルの3つを、あなたの内向的特性に合わせて磨く必要があります。</p>
					<img src="../assets/result-index-img02.svg" alt="*" />
					<div class="caption">
						内向性の強弱が、どんなマインドやスキルと組み合わせるかで、人生の良し悪しは雲泥の差になるのだ。
					</div><!-- end .caption -->
					<p>今回の診断では、あなたが自身の内向性をより活かすための(1)マインドセット、(2)コミュニケーションスキル、(3)アウトプットスキルについて網羅しています。</p>
					<p>私たちは、あなたの内向的な人生がよりキラキラと磨かれ、自身の最大限の幸福だけでなく、その幸福が家族や友人や他人の幸福までもを巻き込んでいくことを、心より願っています。</p>
					<h4>さぁ、あなたの人生を輝かせる<br class="sp-disblock">新しい術と道を見つけよう！</h4>
					<router-link class="next" to="/result-detail">診断結果の詳細へ</router-link>
					<h5>次のページで、さらに詳細な診断結果を<br class="sp-disblock">閲覧することができます！</h5>
				</div><!-- end .sentence -->
			</div><!-- end .guidance-wrapper -->
</template>

<script>


export default {
	name: 'ResultIndexLevelIntrovert',
	components: {

	},
	methods:{

	},
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		levelResult:function(){
			return this.$store.getters.levelResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
